const rootText = new Set([
  'title',
  'eyebrow',
  'subtitle',
  'footnote',
  'lead',
  'takeaway',
  'support',
  'statement',
  'quote',
  'attribution',
  'role',
]);
const index = (value) => /^(?:0|[1-9]\d*)$/u.test(value);
const rows = Object.freeze({
  agenda: ['items', 'label', 'detail'],
  bullets: ['bullets', 'text', 'detail'],
  'stat-trio': ['stats', 'label', 'note'],
  'kpi-grid': ['kpis', 'label', 'note'],
  timeline: ['steps', 'label', 'detail', 'marker'],
});
const nestedText = Object.freeze({
  'two-column': columnText,
  comparison: comparisonText,
  closing: (path) => path.length === 2 && path[0] === 'asks' && index(path[1]),
  table: (path) =>
    path.length === 3 && path[0] === 'columns' && index(path[1]) && path[2] === 'label',
  chart: (path) =>
    path.length === 4 &&
    path[0] === 'chart' &&
    path[1] === 'series' &&
    index(path[2]) &&
    path[3] === 'name',
});
const imageTextPaths = Object.freeze({
  'image-feature': (path) =>
    path.length === 1 && ['title', 'caption', 'takeaway'].includes(path[0]),
  'image-text': imageText,
});

/** Declared slide presentation strings only. Values, provenance and layout are not text slots. */
export function isDeckTextPath(layout, path) {
  const imagePath = imageTextPaths[layout];
  if (imagePath) return imagePath(path);
  if (path.length === 1) return rootText.has(path[0]);
  const row = rows[layout];
  if (row && path.length === 3)
    return path[0] === row[0] && index(path[1]) && row.slice(1).includes(path[2]);
  return nestedText[layout]?.(path) ?? false;
}
function imageText(path) {
  if (path.length === 1) return path[0] === 'title';
  if (path[0] !== 'text') return false;
  return (
    (path.length === 2 && path[1] === 'body') ||
    (path.length === 4 &&
      path[1] === 'bullets' &&
      index(path[2]) &&
      ['text', 'detail'].includes(path[3]))
  );
}
function columnText(path) {
  if (path[0] !== 'columns' || !index(path[1])) return false;
  return (
    (path.length === 3 && ['heading', 'body'].includes(path[2])) ||
    (path.length === 4 && path[2] === 'bullets' && index(path[3]))
  );
}
function comparisonText(path) {
  if (!['left', 'right'].includes(path[0])) return false;
  return (
    (path.length === 2 && path[1] === 'heading') ||
    (path.length === 3 && path[1] === 'points' && index(path[2]))
  );
}

export function ownedPathValue(root, path) {
  let current = root;
  for (const key of path) {
    if (
      ['__proto__', 'constructor', 'prototype'].includes(key) ||
      current === null ||
      typeof current !== 'object' ||
      !Object.hasOwn(current, key)
    )
      return undefined;
    current = current[key];
  }
  return current;
}
